import React, { useState } from "react";
import "./chart.css";
import { Box, Typography } from "@mui/material";
import OpenWithIcon from '@mui/icons-material/OpenWith';
import moment from "moment";

const MAX_BAR_HEIGHT = 40;

export default function PrescriptionChart({ data, name, handleOpen, settingType, }) {

    const [hoverData, setHoverData] = useState(null);

    return (
        <Box sx={{
            overflow: 'auto',
            // border:'2px solid red',
            width: '100%',
            // height:'90%',
        }}>
            {handleOpen && <Box sx={{ display: 'flex', justifyContent: 'space-between', alignContent: 'space-between' }}>
                <Typography
                    variant="p"
                    align="left"
                    sx={{ marginLeft: 2, fontSize: "14px", fontWeight: "bold" }}
                >
                    {name}
                </Typography>

                {data && <OpenWithIcon onClick={() => {
                    handleOpen()
                    settingType(name)
                }} sx={{ alignSelf: 'flex-end', right: 20, cursor: 'pointer', fontSize: 'medium' }} />}
            </Box>}
            {!data ?
                <Box sx={{ height:'50px', display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{fontSize:'10px'}}>No data available</Typography>
                </Box>
                    :

                <div className="chart-container" style={{
                    display: 'flex',
                    flexDirection: 'row',
                    whiteSpace: 'nowrap',
                    overflowX: 'auto', marginTop: '2%',
                    // justifyContent: "flex-start",
                    justifyContent: "center",
                }}>

                    {data?.map((item, index) => {
                        const total = item.activeMedicinesCount;
                        const missed = item.missedMedicines.length;

                        const lightHeight = (total / total) * (handleOpen ? MAX_BAR_HEIGHT : 210);
                        const redHeight = (missed / total) * (handleOpen ? MAX_BAR_HEIGHT : 210);

                        return (
                            <div key={index} className="bar-wrapper" onMouseEnter={() => setHoverData({ x: index, item })}
                                onMouseLeave={() => setHoverData(null)}>

                                <div className="bar" style={{ height: handleOpen ? '39px' : '210px', width: handleOpen ? '11px' : '30px' }}>
                                    {total === 0 ? (
                                        <div className="bar-grey" style={{ height: handleOpen ? MAX_BAR_HEIGHT : '210px' }}></div>
                                    ) : (
                                        <>
                                            <div className="bar-light" style={{ height: lightHeight, }}></div>
                                            {missed > 0 && (
                                                <div className="bar-red" style={{ height: redHeight }}>
                                                    <span className="bar-label" style={{ fontSize: handleOpen ? '6px' : '15px', marginTop: handleOpen ? '4px' : '10px' }}>{missed}</span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>


                                <div className="week-text" style={{ fontSize: handleOpen ? '9px' : '12px' , fontWeight:'bold'}}>{moment(item.date).format("DD MMM")}</div>
                                {/* Tooltip */}
                                {hoverData?.x === index && (
                                    <div className="tooltip">
                                        <div className="tooltip-title">
                                            Pending: {missed}/{total}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            }

        </Box>
    );
}
